// extracted by mini-css-extract-plugin
export default {"block":"aYA9ul","external":"bYA9ul"};